module.exports = __webpack_public_path__ + "img/list19.0ce83901.jpeg";